import { useQuery } from "@tanstack/react-query";

import {
  getBillingTransactions,
  type TransactionType,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { BILLING_QUERY_KEYS } from "./queryKeys";

export interface BillingTransactionsQueryParams {
  offset?: number;
  limit?: number;
  transactionType?: TransactionType | null;
}

export function useBillingTransactionsQuery(
  params: BillingTransactionsQueryParams,
) {
  const { offset, limit, transactionType } = params;

  return useQuery({
    queryKey: BILLING_QUERY_KEYS.transactions(params),
    queryFn: processResponse(() =>
      getBillingTransactions(offset, limit, transactionType),
    ),
  });
}
